import React, { useState, useEffect } from "react";
import styles from "./SingleProduct.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";

// navbar
import logo from "../../assets/images/logo.png";
import viewcart from "../../assets/icons/viewcart.png";

const SingleProduct = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const navigate = useNavigate();


  // to get single product details
  const { productId } = useParams();
  const [product, setProduct] = React.useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getProductById/${productId}`
        );
        setProduct(response.data);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProduct();
  }, [productId]);

  // product add to cart
  const addToCart = async (product) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await axios.post(
        `${MAIN_URL}/api/cart/addToCart/${product._id}`,
        null,
        config
      );
      toast.success(`${product.productName} added to cart!`);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Failed to add product to cart");
    }
  };
// count the cart prodcts 

const [cartItems, setCartItems] = useState([]);


useEffect(() => {
  const fetchCartItems = async () => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${MAIN_URL}/api/cart/getCartItems`,
        config
      );
      setCartItems(response.data.products);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  fetchCartItems();
}, []);

const totalQuantity = cartItems.reduce((total, item) => total + item.quantity, 0);


// Carousel logic 
const [activeIndex, setActiveIndex] = useState(0);

const handleCarouselItemClick = (index) => {
  setActiveIndex(index);
};

  return (
    <>
      <div className={styles.singleProduct}>
        <Header />
        {/* <Navbar /> */}
        {product && (
          <div className={styles.navbar}>
            <div className={styles.left}>
              <div className={styles.logo}>
                <img src={logo} alt="" />
                <p>Musicart</p>
              </div>
              <div className={styles.page}>Home/ {product.productName}</div>
            </div>
            <div className={styles.right}>
              <div className={styles.viewcart}>
                <img src={viewcart} alt="cart" />
                <button className={styles.cart_btn}>
                  <NavLink
                    className={styles.navlink_page_cart_btn}
                    to="/viewcart"
                  >
                    view cart
                  </NavLink>
                </button>
                <p>{totalQuantity} </p> 
              </div>
            </div>
          </div>
        )}
        {product ? (
          <div className={styles.product_mainContainer}>
            {/* BACK BUTTON  */}
            <div className={styles.product_back_btn}>
              <NavLink to="/home">
                <button className={styles.back_btn}>Back to products</button>
              </NavLink>
            </div>
           
            <div className={styles.product_shortdetails}>
              <p>{product.shortDescription}</p>
            </div>
          
            <div className={styles.product_all_details}>
              <div className={styles.product_single_image}>
              <AliceCarousel
                  items={product.carouselImgUrls.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`carousel_${index}`}
                      onClick={() => handleCarouselItemClick(index)}
                      className={index === activeIndex ? styles.active : ""}
                    />
                  ))}
                  autoPlay
                  autoPlayInterval={3000}
                  infinite
                  dotsDisabled={true}
                />
              </div>
              {/* single product  */}
              <div className={styles.product_details}>
                <p className={styles.product_name}> {product.productName} </p>

                <div className={styles.ratings_section}>
                  <div className={styles.star_icon}>
                    {Array.from({ length: 5 }, (_, index) => {
                      const filledStars = Math.floor(
                        product.reviews.starRating
                      );
                      const hasHalfStar = product.reviews.starRating % 1 !== 0;
                      if (index < filledStars) {
                        return <FaStar key={index} className="icon" />;
                      } else if (hasHalfStar && index === filledStars) {
                        return <FaStarHalfAlt key={index} className="icon" />;
                      } else {
                        return <AiOutlineStar key={index} className="icon" />;
                      }
                    })}
                  </div>{" "}
                  <p>({product.reviews.reviewCount} Customer reviews)</p>
                </div>

                <div className={styles.price}> Price - ₹ {product.price} </div>
                <div className={styles.about}>
                  <span className={styles.color}>{product.color} | </span>
                  <span className={styles.type}>{product.productType}</span>
                </div>
                <div className={styles.details_points}>
                  <p>About this item</p>
                  <ul>
                    {product.fullDescription &&
                      product.fullDescription
                        .split("\n")
                        .map((description, index) => (
                          <li key={index}>{description}</li>
                        ))}
                  </ul>
                </div>

                <div className={styles.stock}>
                  <span>Available -</span> {product.stock}
                </div>
                <div className={styles.brand}>
                  <span>Brand -</span> {product.brand}
                </div>
              </div>
              {/* single product  */}
            </div>
            {/* CAROUSAL */}
            <div className={styles.product_img_btn}>
              <div className={styles.product_carousal}>
                {product.carouselImgUrls.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`product_carousal ${index + 1}`}
                  />
                ))}
              </div>
              <div className={styles.btns}>
                <button
                  className={styles.add_to_cart_btn}
                  onClick={() => addToCart(product)}
                  style={{ cursor: "pointer" }}
                >
                  Add to cart
                </button>
                <button className={styles.buy_now_btn}> <NavLink to="/viewcart" className={styles.link_btn}>Buy Now</NavLink> </button>
              </div>
            </div>
            {/* CAROUSAL */}
          </div>
        ) : (
          <div>Loading...</div>
        )}
        <Footer />
      </div>
      <ToastContainer />
    </>
  );
};

export default SingleProduct;
